import App from 'next/app';
import Head from 'next/head';
import React from 'react';
import wrapper, { di } from 'src/modules';
import DiContext, { processRegisterDependencies } from '@aveneo/frontmoon-di/lib';

import Fingerprint from 'src/components/Fingerprint';
import Modal from 'src/components/Modal';
import LocaleProvider from 'src/components/LocaleProvider';
import RestaurantColors from 'src/components/RestaurantColors';
import Notifications from 'src/components/Notifications';
import Hreflangs from 'src/components/Hreflangs';
import getAppDependencies from 'src/dependencies';

import 'src/styles/globals.scss';
import 'react-multi-carousel/lib/styles.css';
import { detectLanguage } from 'src/utils/language';

class MyApp extends App {
    state = {
        isChangingRoute: false
    }

    constructor(props) {
        super(props);

        processRegisterDependencies([getAppDependencies], di, {});

        if (!di.container.API_URL && typeof window !== 'undefined') {
            di.value('API_URL', window.location.origin);
        }
    }

    static getInitialProps = wrapper.getInitialAppProps(() => async (context) => {
        const { lang, cookies } = detectLanguage(context.ctx);

        const appProps = await App.getInitialProps(context);

        const host = context.ctx.req?.headers?.host || window.location.host;
        let protocol = 'https://';
        if (host.indexOf('localhost') > -1) {
            protocol = 'http://';
        }

        appProps.pageProps = {
            ...appProps.pageProps,
            cookies,
            lang,
            isSSR: !!context.req,
            routeContext: {
                origin: `${protocol}${host}`,
                path: context.router.asPath
            }
        };

        di.value('API_URL', `${protocol}${host}`);

        return { ...appProps };
    })

    render() {
        const { Component, pageProps } = this.props;

        const { ViewportWatcher } = di.container;

        return (
            <DiContext.Provider value={di}>
                <LocaleProvider lang={pageProps.lang}>
                    <ViewportWatcher>
                        <>
                            <Hreflangs routeContext={pageProps.routeContext} />
                            <Head>
                                <meta
                                  name="viewport"
                                  content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                                />
                                <meta name="facebook-domain-verification" content="93mk2pkcrwqu7dfu7zzi9gl743i3z0" />
                                <meta name="mobile-web-app-capable" content="yes" />
                                <meta name="apple-mobile-web-app-capable" content="yes" />
                                <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                                <meta
                                  name="description"
                                  // eslint-disable-next-line max-len
                                  content="Zamawiaj prosto do stolika w swojej ulubionej restauracji. Przeglądaj menu, zamawiaj wspólnie ze znajomymi i śledź swoje zamówienie z apetit.io."
                                  key="description"
                                />
                                <link rel="preconnect" href="https://fonts.googleapis.com" />
                                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                                <link href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap" rel="stylesheet" />
                                <link rel="manifest" href="/manifest.json" />
                            </Head>
                            <RestaurantColors />
                            <Fingerprint />
                            <Component {...pageProps} />
                            <Modal />
                            <Notifications />
                        </>
                    </ViewportWatcher>
                </LocaleProvider>
            </DiContext.Provider>
        );
    }
}

export default wrapper.withRedux(MyApp);
